"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toLower = _interopRequireDefault(require("lodash/toLower"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EnvUtil = /*#__PURE__*/function () {
  function EnvUtil() {
    _classCallCheck(this, EnvUtil);
  }

  _createClass(EnvUtil, null, [{
    key: "getAppEnv",
    value: function getAppEnv() {
      if (EnvUtil.isApp) {
        var domain = window.location.hostname;

        if (domain) {
          domain = domain.toLowerCase();

          if (domain.match(/local/)) {
            return EnvUtil.ENV_LOCAL;
          } else if (domain.match(/test/)) {
            return EnvUtil.ENV_TEST;
          } else if (domain.match(/stg/)) {
            return EnvUtil.ENV_STG;
          } else {
            return EnvUtil.ENV_PROD;
          }
        }
      }

      return undefined;
    }
  }, {
    key: "getNodeEnv",
    value: function getNodeEnv() {
      if (EnvUtil.isNode) {
        return (0, _toLower.default)(process.env.NODE_ENV);
      }

      return undefined;
    }
    /**
     * Main method to check on the current env.
     * May be extended to check on the currency NODE JS env.
     * @returns {*}
     */

  }, {
    key: "getEnv",
    value: function getEnv() {
      return EnvUtil.getAppEnv() || EnvUtil.getNodeEnv();
    }
  }, {
    key: "isApp",
    get: function get() {
      try {
        return !!(window && window.location);
      } catch (e) {
        return false;
      }
    }
  }, {
    key: "isNode",
    get: function get() {
      try {
        return !!(process && process.env);
      } catch (e) {
        return false;
      }
    }
  }, {
    key: "isProd",
    get: function get() {
      return EnvUtil.ENV_PROD === EnvUtil.getEnv();
    }
  }, {
    key: "isStg",
    get: function get() {
      return EnvUtil.ENV_STG === EnvUtil.getEnv();
    }
  }, {
    key: "isTest",
    get: function get() {
      return EnvUtil.ENV_TEST === EnvUtil.getEnv();
    }
  }, {
    key: "isLocal",
    get: function get() {
      return EnvUtil.ENV_LOCAL === EnvUtil.getEnv();
    }
  }]);

  return EnvUtil;
}();

exports.default = EnvUtil;

_defineProperty(EnvUtil, "ENV_LOCAL", 'local');

_defineProperty(EnvUtil, "ENV_TEST", 'test');

_defineProperty(EnvUtil, "ENV_STG", 'staging');

_defineProperty(EnvUtil, "ENV_PROD", 'production');